import script from "./ClientsView.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientsView.vue?vue&type=script&setup=true&lang=js"

import "./ClientsView.vue?vue&type=style&index=0&id=27f93653&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27f93653"]])

export default __exports__